export default __webpack_public_path__ + "static/media/new-tab.6ddbacfb.svg";